import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Menu, X, User } from 'lucide-react';
import { Button } from './ui/button';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user'));

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsOpen(false);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('user');
    navigate('/');
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-black/90 backdrop-blur-md border-b border-green-900/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="flex items-center space-x-2">
            <img src="/logo.webp" alt="Swenzy" className="w-10 h-10 rounded-lg" />
            <span className="text-2xl font-bold text-green-400">Swenzy</span>
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            <button onClick={() => scrollToSection('packages')} className="text-gray-300 hover:text-green-400 transition-colors">
              Paketler
            </button>
            <button onClick={() => scrollToSection('bots')} className="text-gray-300 hover:text-green-400 transition-colors">
              Botlar
            </button>
            <button onClick={() => scrollToSection('services')} className="text-gray-300 hover:text-green-400 transition-colors">
              Ek Hizmetler
            </button>
            <button onClick={() => scrollToSection('testimonials')} className="text-gray-300 hover:text-green-400 transition-colors">
              Müşteri Yorumları
            </button>
            <button onClick={() => scrollToSection('faq')} className="text-gray-300 hover:text-green-400 transition-colors">
              SSS
            </button>
            
            {user ? (
              <div className="flex items-center space-x-4">
                <Link to={user.role === 'admin' ? '/admin' : '/dashboard'}>
                  <Button variant="outline" className="border-green-500 text-green-400 hover:bg-green-500 hover:text-black">
                    <User className="w-4 h-4 mr-2" />
                    {user.role === 'admin' ? 'Yönetici Paneli' : 'Panelim'}
                  </Button>
                </Link>
                <Button onClick={handleLogout} variant="ghost" className="text-gray-400 hover:text-red-400">
                  Çıkış
                </Button>
              </div>
            ) : (
              <div className="flex items-center space-x-4">
                <Link to="/login">
                  <Button variant="ghost" className="text-gray-300 hover:text-green-400">
                    Giriş
                  </Button>
                </Link>
                <Link to="/register">
                  <Button className="bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-black font-semibold">
                    Kayıt Ol
                  </Button>
                </Link>
              </div>
            )}
          </div>

          <button onClick={() => setIsOpen(!isOpen)} className="md:hidden text-green-400">
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {isOpen && (
        <div className="md:hidden bg-black/95 border-t border-green-900/30">
          <div className="px-4 py-4 space-y-3">
            <button onClick={() => scrollToSection('packages')} className="block w-full text-left text-gray-300 hover:text-green-400 py-2">
              Paketler
            </button>
            <button onClick={() => scrollToSection('bots')} className="block w-full text-left text-gray-300 hover:text-green-400 py-2">
              Botlar
            </button>
            <button onClick={() => scrollToSection('services')} className="block w-full text-left text-gray-300 hover:text-green-400 py-2">
              Ek Hizmetler
            </button>
            <button onClick={() => scrollToSection('testimonials')} className="block w-full text-left text-gray-300 hover:text-green-400 py-2">
              Müşteri Yorumları
            </button>
            <button onClick={() => scrollToSection('faq')} className="block w-full text-left text-gray-300 hover:text-green-400 py-2">
              SSS
            </button>
            {user ? (
              <>
                <Link to={user.role === 'admin' ? '/admin' : '/dashboard'} className="block">
                  <Button className="w-full bg-green-500 hover:bg-green-600 text-black">
                    {user.role === 'admin' ? 'Yönetici Paneli' : 'Panelim'}
                  </Button>
                </Link>
                <Button onClick={handleLogout} variant="ghost" className="w-full text-red-400">
                  Çıkış
                </Button>
              </>
            ) : (
              <>
                <Link to="/login" className="block">
                  <Button variant="outline" className="w-full border-green-500 text-green-400">
                    Giriş
                  </Button>
                </Link>
                <Link to="/register" className="block">
                  <Button className="w-full bg-gradient-to-r from-green-500 to-green-600 text-black">
                    Kayıt Ol
                  </Button>
                </Link>
              </>
            )}
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;